import mainRoutes from 'data/common/routes';
import environments from './environments';

let allRoutes = environments.getRoutes();

mainRoutes.map((route, path) => {
    route.environment = 'mainRoutes';
    route.path = path;
    allRoutes = allRoutes.setIn([path], route);
});

export default allRoutes;



// WEBPACK FOOTER //
// ./routes.js